import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MediaService } from 'src/app/services/media/media.service';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit,OnDestroy {

  images:any[];
  sub:Subscription[]=[];
  constructor(
    private imgService:MediaService) { 
  }

  ngOnInit(): void {
    this.imgService.getMediaList();
    this.sub[0]= this.imgService.mediaList.snapshotChanges().subscribe(
      list=>{
      this.images=  list.map(item=>{  return {
        $key:item.key,
        ... item.payload.val()
      }});
        this.images=this.images.reverse();
      }
      );
      
  }
 
  ngOnDestroy(){
    this.sub.forEach(s=>{
      s.unsubscribe();
    })
  }
}
